import React, { useEffect, useReducer} from 'react';
import {Container, Row, Nav, Button,} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
const Footer = () => {
    



    return (
        
<div id="footerlastbox">
<div class="container">
<Row className="aboutfooterfirstbox mobilefooter">

<div className="col-md-3 footer3">
     <h6 className="footermenuhead">Follow Us</h6>

<br/>

<p className="footermenup">
<a target="_blank" href="https://linkedin.com/earth-vii"><img className=''  src="images/icons/linkedin.png"/></a>
{/* <a target="_blank" href="https://facebook.com/earthvii_"><img className='footersocialp' src="images/icons/facebook.png"/></a> */}
<a target="_blank" href="https://instagram.com/earthvii_"><img className='footersocialp' src="images/icons/instagram.png"/></a>
{/* <a target="_blank" href="https://twitter.com/earthvii_"><img className='footersocialp' src="images/icons/twitter.png"/></a> */}
</p>

     <br/>
     </div>


        <div className="col-md-2">
        <h6 className="footermenuhead">Quick Links</h6>
        <br/>
                <Nav.Link href="/about"  >     <p  className="footermenubody">About Us</p></Nav.Link>
                <Nav.Link  href="/homes" >     <p   className="footermenubody">Earth VII Homes</p></Nav.Link>
                <Nav.Link  href="/apartments"  >     <p   className="footermenubody">EarthVII Apartments</p></Nav.Link>
                <Nav.Link  href="/blog" >     <p   className="footermenubody">Blog</p></Nav.Link>


        </div>

   

     <div className="col-md-4 footer2">
     <h6 className="footermenuhead">Contact Us</h6>
     <br/>
     <div className='innersesventhbody'>
                    <Row>
                        <div class="col-md-1 col-4">
                           <p className="footerjoin2"><img  src="images/icons/phone.png"/></p>
                        </div>

                        <div class="col-md-9 col-8">
                            <p className='innerboxsevendescriptiontext'><a style={{textDecoration:"none", color:"#E5E5E5"}} href="tel:+234 9016854815">+234 901 685 4815</a></p>
                        </div>


                        
                    </Row>

                    {/* <p className='innerboxsevendescriptiontext formobileonly'><img src="images/icons/phone.png"/> +234 123 456 7890</p> */}


                    <Row className="innersesventhbodyrow">
                        <div class="col-md-1 col-4">
                            <img className="footerjoin2" src="images/icons/mail.png"/>
                        </div>

                        <div class="col-md-9 col-8">
                            <p className='innerboxsevendescriptiontext'><a style={{textDecoration:"none", color:"#D9D9D9"}} href="mailto:hello@earthvii.com">info@earthvii.com</a></p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-md-1 col-4">
                            <img className="footerjoin2" src="images/icons/location.png"/>
                        </div>

                        <div class="col-md-9 col-8">
                            <p className='innerboxsevendescriptiontext'>B24D, Platinum mega mall, Katampe road, Jahi Abuja</p>
                        </div>
                    </Row>

              
                    </div>

     
     </div>

     <div className="col-md-3 footer2">
     {/* <h6 className="footermenuhead">Newsletter Subscription</h6>
     <p className="innerboxsevendescriptiontext footerjoin">Join our weekly newsletter list.</p>
  
     <input type="email" class="form-control form-control-lg hminput footerinput" id=""placeholder="Name"/>
     <input type="email" class="form-control form-control-lg hminput footerinput footerinputlast" id=""placeholder="E-mail Address"/>
     <p className="footerbuttonp"><button type="submit" class="footerbutton">Subscribe</button></p> */}


     </div>



  
    </Row>
 
    </div>



    <br/>
    <br/>
    <br/>



    </div>

    )
}


export {Footer as default}